var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',_vm._g(_vm._b({attrs:{"label":"Purpose","item-text":"processPurposeName","item-value":"processPurposeId","items":_vm.purposesWithAll}},'Dropdown',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }